export default "__VITE_ASSET__CYBWgDdU__"